<template>
  <in-viewport>
    <div class="job-offers-section">
      <base-layout underline>
        <border-box slot="sidebar"><h2 v-html="heading"/></border-box>
        <div slot="content">
          <border-box>
            <p v-html="description" class="job-offers-section__description"/>
          </border-box>
          <grid-row>
            <div
              v-for="(offer, i) in items"
              :key="i"
              :class="`job-offers-section__item--${ type(i) }`"
              class="job-offers-section__item"
            >
              <border-box :xs-hide="!offer" class="job-offers-section__item-box">
                <grid-row class="job-offers-section__item-row">
                  <div class="job-offers-section__item-inner">
                    <job-offer
                      v-if="offer"
                      :title="offer.title"
                      :type="offer.type"
                      :description="offer.description"
                      :link="offer.link"
                    />
                  </div>
                </grid-row>
              </border-box>
            </div>
          </grid-row>
        </div>
      </base-layout>
    </div>
  </in-viewport>
</template>

<script>
import BaseLayout from '@/components/BaseLayout'
import BorderBox from '@/components/BorderBox'
import JobOffer from '@/containers/Contact/JobOffer'

export default {
  components: {
    BaseLayout,
    BorderBox,
    JobOffer
  },
  props: {
    heading: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    offers: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    items () {
      return this.offers.length % 2
        ? [...this.offers, false]
        : this.offers
    },
    type () {
      return i => i % 2 ? 'even' : 'odd'
    }
  }
}
</script>

<style lang="scss" scoped>
  .job-offers-section {
    &__description {
      @include text(big, medium);
      @include vertical-space((bottom: 2), padding);

      @media(min-width: 1160px){
        max-width: 88.88889%;
      }

    }

    &__item {
      @include grid-column((xs: 12, md: 6));

      &-inner {
        @include grid-column((xs: 12));
      }

      @include media-up(lg) {
        &--odd {
          @include nested-column-width(4, 9, lg)
        }

        &--even {
          @include nested-column-width(5, 9, lg)
        }

        &--even &-inner {
          @include nested-column-width(4, 5, lg)
        }
      }

      &-box,
      &-row {
        height: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Contact/JobOffersSection.vue